import React from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import "./marketing.css";

const Demo = () => {
  return (
    <div className="tlm-home tlm-dark min-vh-100 py-5">
      <Container>
        <Row className="justify-content-center">
          <Col lg="8">
            <Card className="border-0 shadow-sm">
              <CardBody className="p-4 p-md-5 text-center">
                <p className="text-uppercase text-primary font-weight-bold small mb-2">
                  Live Demo
                </p>
                <h1 className="font-weight-bold mb-3">
                  See how TrackLastMile runs a full delivery operation end-to-end.
                </h1>
                <p className="text-muted mb-4">
                  In 15 minutes, we will walk you through customer ordering, store fulfillment,
                  driver dispatch, live GPS tracking, and admin reporting so you can evaluate fit quickly.
                </p>
                <div className="d-flex flex-wrap justify-content-center">
                  <Button color="primary" tag={Link} to="/trial-register" className="m-2 px-4">
                    Book Demo
                  </Button>
                  <Button color="outline-primary" tag={Link} to="/trial-register" className="m-2 px-4">
                    Contact Sales
                  </Button>
                  <Button color="outline-dark" tag={Link} to="/pricing" className="m-2 px-4">
                    View Pricing
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Demo;
